
<h1>
  <span>Datenschutzerklärung</span> <br>
  IDOGO GmbH
</h1>
<p>
  <b>Allgemeiner Hinweis und Pflichtinformationen</b>
  <br><br>
  <b>Benennung der verantwortlichen Stelle</b>
  <br>
  <b>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</b><br>
  IDOGO GmbH <br>
  Böheimstraße 47/1 &bull; 70199 Stuttgart <br>
  Telefon: <a href="tel:+4971162007251">+49 (0)711 / 62 00 725-1</a> <br>
  Fax: +49 (0)711 / 62 00 725-3
  E-Mail: <a href="mailto:info@idogo.de">info@idogo.de</a>
  <br><br>
  <b>Die verantwortliche Stelle entscheidet allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, Kontaktdaten o. Ä.).</b>
  <br><br>
  <b>Widerruf Ihrer Einwilligung zur Datenverarbeitung</b><br>
  Nur mit Ihrer ausdrücklichen Einwilligung sind einige Vorgänge der Datenverarbeitung möglich. Ein Widerruf Ihrer bereits erteilten Einwilligung ist jederzeit möglich. Für den Widerruf genügt eine
  formlose Mitteilung per E-Mail. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
  <br><br>
  <b>Recht auf Beschwerde bei der zuständigen Aufsichtsbehörde</b><br>
  Als Betroffener steht Ihnen im Falle eines datenschutzrechtlichen Verstoßes ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
  Zuständige Aufsichtsbehörde bezüglich datenschutzrechtlicher Fragen ist der Landesdatenschutzbeauftragte des Bundeslandes, in dem sich der Sitz unseres Unternehmens befindet.
  Der folgende Link stellt eine Liste der Datenschutzbeauftragten sowie deren Kontaktdaten bereit: <a href="https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html" target="_blank">
  Link zur Liste</a>
  <br><br>
  <b>Recht auf Datenübertragbarkeit</b><br>
  Ihnen steht das Recht zu, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an Dritte aushändigen zu lassen. Die Bereitstellung
  erfolgt in einem maschinenlesbaren Format. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.
  <br><br>
  <b>Recht auf Auskunft, Berichtigung, Sperrung, Löschung</b><br>
  Sie haben jederzeit im Rahmen der geltenden gesetzlichen Bestimmungen das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, Herkunft der Daten, deren Empfänger und
  den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten. Diesbezüglich und auch zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich
  jederzeit über die im Impressum aufgeführten Kontaktmöglichkeiten an uns wenden.
  <br><br>
  <b>SSL- bzw. TLS-Verschlüsselung</b><br>
  Aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, die Sie an uns als Seitenbetreiber senden, nutzt unsere Website eine SSL-bzw. TLS-Verschlüsselung. Damit sind Daten, die
  Sie über diese Website übermitteln, für Dritte nicht mitlesbar. Sie erkennen eine verschlüsselte Verbindung an der „https://“ Adresszeile Ihres Browsers und am Schloss-Symbol in der
  Browserzeile.
  <br><br>
  <b>Server-Log-Dateien</b><br>
  In Server-Log-Dateien erhebt und speichert der Provider der Website automatisch Informationen, die Ihr Browser automatisch an uns übermittelt. Dies sind:
</p>
<ul>
  <li>Besuchte Seite auf unserer Domain</li>
  <li>Datum und Uhrzeit der Serveranfrage</li>
  <li>Browsertyp und Browserversion</li>
  <li>Verwendetes Betriebssystem</li>
  <li>Referrer URL</li>
  <li>Hostname des zugreifenden Rechners</li>
  <li>IP-Adresse</li>
</ul>
<p>
  Es findet keine Zusammenführung dieser Daten mit anderen Datenquellen statt. Die Verarbeitung dieser Daten erfolgt auf Grundlage des Art. 6 Abs. 1 lit. f DSGVO. Das berechtigte Interesse des
  Webseitenbetreibers liegt in der technisch fehlerfreien Darstellung und der Optimierung unserer Webseite. Aus diesem Grund müssen Server-Log-Dateien erfasst werden.
</p>
